import { ClientEntity } from "../../../types/clients/Entity";

export const deleteRouteApi = (
  apiInstance: ClientEntity.API
) => (uid: string) => apiInstance.collection( 'route' )
  .delete(uid)
;
